import { render, staticRenderFns } from "./NewsTickerWidget.vue?vue&type=template&id=513eabde&"
import script from "./NewsTickerWidget.vue?vue&type=script&lang=ts&"
export * from "./NewsTickerWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports